module.exports = __webpack_public_path__ + "img/mls_logo.3b47bb2a.jpg";